export default __webpack_public_path__ + "src/images/404-weg-zu-ende.jpg";